/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import loop from './scrollSwapColor.js';

//Fonts
import { library, dom, config } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faTwitter, faLinkedinIn, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';


library.add(
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faYoutube,
  faInstagram
)
config.searchPseudoElements = true;

//Add FontAwesome
library.add();
dom.watch();

$(document).ready(() => {
  //swap color
  loop();
  // console.log('Hello world');
});
